import { request } from 'utils/requests'

// Meus dados (nome, telefone, e-mail de avisos) e minha senha
export const salvarMeusDados = async (dados) => (await request.patch('/collaborator/me', dados)).data
export const trocarMinhaSenha = async (atual, nova) => (await request.post('/collaborator/me/senha', { atual, nova })).data
